import * as t from 'io-ts';
export var withUndefined = function withUndefined(c) {
  return t.union([c, t.undefined]);
};